// 管理后台路由：自包含命名空间，仅通过根 router/index.js 注入，
// 不引用 test-vue-01 其他业务模块，保持高内聚低耦合。
import AdminLayout from './layouts/AdminLayout.vue'
import Login from './views/Login.vue'
import Dashboard from './views/Dashboard.vue'
import Administrators from './views/Administrators.vue'
import Roles from './views/Roles.vue'
import Menus from './views/Menus.vue'
import Permissions from './views/Permissions.vue'
import Policies from './views/Policies.vue'
import Users from './views/Users.vue'
import UserBlacklist from './views/userBlacklist.vue'
import Sirens from './views/Sirens.vue'
import Jizhais from './views/Jizhais.vue'
import Prices from './views/Prices.vue'
import AutoDates from './views/AutoDates.vue'
import CourseConfig from './views/CourseConfig.vue'
// 客服管理：复用客服工作台（/cs/*）的页面组件，由 CustomerServiceHost 提供 .cs-root 作用域后内嵌展示
import CustomerServiceHost from './views/CustomerServiceHost.vue'
import CsSelectionOrders from '../customerService/views/SelectionOrders.vue'
import OrderManage from './views/OrderManage.vue'
import PermissionOrders from './views/PermissionOrders.vue'
import SystemSettings from './views/SystemSettings.vue'

const routes = [
  {
    path: '/admin/login',
    name: 'admin-login',
    component: Login,
    meta: { public: true, title: '后台登录' }
  },
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/dashboard',
    meta: { requiresAuth: true },
    children: [
      { path: 'dashboard', name: 'admin-dashboard', component: Dashboard, meta: { title: '概览' } },
      { path: 'administrators', name: 'admin-administrators', component: Administrators, meta: { title: '管理员' } },
      { path: 'roles', name: 'admin-roles', component: Roles, meta: { title: '角色' } },
      { path: 'menus', name: 'admin-menus', component: Menus, meta: { title: '菜单' } },
      { path: 'permissions', name: 'admin-permissions', component: Permissions, meta: { title: '权限' } },
      { path: 'policies', name: 'admin-policies', component: Policies, meta: { title: '策略' } },
      { path: 'users', name: 'admin-users', component: Users, meta: { title: '用户管理' } },
      { path: 'user-blacklist', name: 'admin-user-blacklist', component: UserBlacklist, meta: { title: '用户黑名单' } },
      { path: 'sirens', name: 'admin-sirens', component: Sirens, meta: { title: '私人定制' } },
      { path: 'jizhais', name: 'admin-jizhais', component: Jizhais, meta: { title: '吉宅订单' } },
      { path: 'prices', name: 'admin-prices', component: Prices, meta: { title: '价格设置' } },
      { path: 'autodates', name: 'admin-autodates', component: AutoDates, meta: { title: '自动择日' } },
      // 日课配置：内容区里 iframe 内嵌前台日历式日课页（/tianxing/autoSelect），
      // route 名与菜单项 autoselect 对应，不新开窗口
      { path: 'course-config', name: 'admin-course-config', component: CourseConfig, meta: { title: '日课配置' } },
      { path: 'orders', name: 'admin-orders', component: OrderManage, meta: { title: '择日业务办理' } },
      // 权限开通订单：星盘页「开通功能」的明细账（用户 id ↔ 订单 ↔ 权限），对账与导出用
      { path: 'permission-orders', name: 'admin-permission-orders', component: PermissionOrders, meta: { title: '权限开通订单' } },
      // 客服管理：客服工作台的业务页在后台内容区里内嵌展示（meta.csView 指定具体页面组件）
      { path: 'cs-selection-orders', name: 'admin-cs-selection-orders', component: CustomerServiceHost, meta: { title: '自动择日提交信息', csView: CsSelectionOrders } },
      { path: 'system', name: 'admin-system', component: SystemSettings, meta: { title: '系统设置' } }
    ]
  }
]

export default routes
